import React from "react";
import { CommonInput } from "../common/CommonInput";
import { BiSearchAlt2 } from "react-icons/bi";
import {
  Modal,
  MDHeader,
  MDTitle,
  EscBtn,
  Guidance,
  AddressForm,
  AddressList,
  RoadName,
  JibunAddress,
  Jibun,
  ZipCode,
  ModalFooter,
} from "./layout";

export const AddrModal = ({
  address,
  searchAddressModal,
  getAddress,
  dataHandler,
}) => {
  return (
    <Modal>
      <MDHeader>
        <MDTitle>주소 검색</MDTitle>
        <EscBtn onClick={searchAddressModal}>X</EscBtn>
      </MDHeader>
      <CommonInput
        styleWidth={"328px"}
        placeHolder="주소 또는 건물명으로 검색"
        onKeyPress={(e) => getAddress(e.target.value)}
        searchImage={BiSearchAlt2}
        style={{
          margin: 20,
        }}
      />
      {address && address.length < 1 ? (
        <Guidance>
          <p>
            찾으시려는 도로명 주소의 건물번호 또는 시설명까지
            <br />
            상세히 입력 후 검색해주세요.
            <br />
            예)중앙동, 불정로432번길
          </p>
        </Guidance>
      ) : (
        address?.map((addr, index) => (
          <AddressForm key={index}>
            <AddressList onClick={() => dataHandler(addr)}>
              <RoadName>{addr.roadAddr}</RoadName>
              <JibunAddress>
                <Jibun>지번</Jibun>
                {addr.jibunAddr}
              </JibunAddress>
            </AddressList>
            <ZipCode>{addr.zipNo}</ZipCode>
          </AddressForm>
        ))
      )}

      <ModalFooter>
        <p>
          &#183;기본주소 선택 후 상세주소를 반드시 입력해주세요. 상세주소가 없는
          경우 주소지 특징을 입력해주세요. <br /> &#183;2016년 8월 1일부터는
          5가지 우편번호 사용이 의무화됩니다. 도로명주소 + 5자리 우편번호로
          등록하셔서 서비스 이용에 불편함이 없도록 하시길 바랍니다.
        </p>
      </ModalFooter>
    </Modal>
  );
};
